import React, { useEffect, useState } from "react";
import PaginationResult from '../../../LobbyContent/SubComponents/PaginationResult';
import { useDispatch, useSelector } from "react-redux";
import { pageNumberInfo, setTotalNoResult } from "../../../../redux/actions";
import { makeAjax, url } from "../../../../helpers/global_helper";
import { withTranslation } from "react-i18next";

function DasarBigSmallResult(props) {
  const { startDate, endDate, submitTrigger, checkSelected, setSubmitTrigger, pageCall, pageCallFunction } = props;
  const dispatch = useDispatch();
  const country_name = useSelector((state) => state.CommonConfig.country_name);
  const [last10Result, setLast10Result] = useState([]);
  const [result, setResult] = useState("");
  const [resetPage, setResetPage] = useState(false);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const pageNumber = useSelector((state) => state.paginationData.pageNumber);
  const [selected, setSelected] = useState('bigsmall');
  const [newStartDate, setNewStartDate] = useState(startDate);
  const [newEndDate, setNewEndDate] = useState(endDate);

  useEffect(() => {
    setResetPage(true);
    setLast10Result([]);
    setNewStartDate('');
    setNewEndDate('');
    fetchData();
  }, [country_name]);

  useEffect(() => {
    setNewStartDate(startDate);
    setNewEndDate(endDate);
  }, [startDate, endDate]);

  const fetchData = (page = 0) => {
    setLast10Result([]);
    const params = {
      gameId: gameId,
      page: pageNumber,
      length: 30,
      startDate: submitTrigger > 0 || page > 0 ? newStartDate : "",
      endDate: submitTrigger > 0 || page > 0 ? newEndDate : ""
    };

    makeAjax(
      url.TOGEL_API.getResultTogelNew,
      params,
      url.TOGEL_MS_EXT
    ).then((response) => {
      if (response.code === "data_not_found") {
        setLast10Result([]);
        if (page === 0 || submitTrigger > 0) {
          setSubmitTrigger();
        }
        // setSubmitTrigger();
        return;
      }
      setLast10Result(response.data.data);
      if (page === 0 || submitTrigger > 0) {
        setSubmitTrigger();
        pageCallFunction()
      }
      dispatch(setTotalNoResult(response.data.total));
    });
  }

  useEffect(() => {
    // if(submitTrigger === 1) {
    fetchData(1);
    // }
  }, [gameId, pageNumber]);

  useEffect(() => {
    // Ensure it triggers only after an actual submit
    if (submitTrigger === 1) {
      setResetPage(true);
      fetchData();
    }

  }, [submitTrigger]);

  // Function to reset the `resetPage` state back to false
  const handleResetPageNo = () => {
    setResetPage(false);
  };

  // Function to determine if the result is 'Big' or 'Small'
  const getBigOrSmall = (number) => {
    if (number.length < 4) return null;

    const lastTwoDigits = parseInt(number.slice(-2), 10);
    let sum = lastTwoDigits % 10 + Math.floor(lastTwoDigits / 10);

    if (sum > 9) {
      sum = sum % 10 + Math.floor(sum / 10);
    }

    return sum <= 4 ? 'small' : 'big';
  };

  const getTranslatedDay = (day) => {
    switch (day.toLowerCase()) {
      case "monday":
        return props.t('monday');
      case "tuesday":
        return props.t('tuesday');
      case "wednesday":
        return props.t('wednesday');
      case "thursday":
        return props.t('thursday');
      case "friday":
        return props.t('friday');
      case "saturday":
        return props.t('saturday');
      case "sunday":
        return props.t('sunday');
      default:
        return day;
    }
  };

  return (
    <>
      <div>
        <div className="data-analysis">
          <div className="cate-heading">
            <h2>{country_name} {props.t('number')} Data {props.t('analysis')}</h2>
          </div>
          <div className="container data-table">
            <table>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>{props.t('day')}</th>
                  <th>{props.t('date')}</th>
                  <th>{props.t('result')}</th>
                  <th>{props.t('big')}</th>
                  <th>{props.t('small')}</th>
                </tr>
              </thead>
              <tbody>
                {last10Result.length > 0 ? (
                  last10Result.map((result, index) => {
                    const date = new Date(result.datetime);
                    const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
                    const bigOrSmall = getBigOrSmall(result.number);
                    const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
                    const translatedDay = getTranslatedDay(dayName);
                    return (
                      <tr
                        key={result.period}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        <td>{index + 1}</td>
                        {/* <td>
                          {date.toLocaleDateString("en-US", { weekday: "long" })}
                        </td> */}
                        <td>{translatedDay}</td>
                        <td>{formattedDate}</td>
                        <td>{result.number}</td>
                        <td>{bigOrSmall === 'big' ? '✓' : ''}</td>
                        <td>{bigOrSmall === 'small' ? '✓' : ''}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="4">No results found</td>
                  </tr>
                )}
              </tbody>
            </table>
            <PaginationResult resetPage={resetPage} handleResetPageNo={handleResetPageNo} />
          </div>
        </div>
      </div>
    </>
  )
}

export default withTranslation()(DasarBigSmallResult);